import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'

import Main from './layout/Main'
import AreaIndex from './pages/area/Index'
import AuthLayout from './pages/auth/AuthLayout'
import FreeLogin from './pages/auth/FreeLogin'
import Loading from './pages/auth/Loading'
import LoginSuccess from './pages/auth/LoginSuccess'
import QRCodeLogin from './pages/auth/QrcodeLogin'
import Customs from './pages/customs/Index'
import Dashboard from './pages/Dashboard'
import Demo from './pages/demo/Index'
import Error500 from './pages/Error'
import Inbound from './pages/inbound/Index'
import MonitorInbound from './pages/monitor/inbound/Index'
import Schedule from './pages/outbound/Index'
import Scan from './pages/outbound/Scan'
import Search from './pages/search/UniversalSearch'
import SettingTabs from './pages/settings/SettingTabs'
import InboundLayout from './pages/warehouse/Index'

import { LoginRoute, ProtectedRoute } from '@/components/RouteGuards'

export const router = createBrowserRouter([
  {
    path: '/auth',
    element: (
      <LoginRoute>
        <AuthLayout>
          <Outlet />
        </AuthLayout>
      </LoginRoute>
    ),
    children: [
      {
        index: true,
        element: <Loading />
      },
      {
        path: 'free',
        element: <FreeLogin />
      },
      {
        path: 'oauth',
        element: <QRCodeLogin />
      },
      {
        path: 'success',
        element: <LoginSuccess />
      },
      {
        path: 'develop',
        element: <>develop</>
      }
    ]
  },
  {
    // 服务器500错误
    path: '/error',
    element: <Error500 />
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Main>
          <Outlet />
        </Main>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true, // 👈 默认子路由
        element: <Dashboard />
      },
      {
        path: 'demo',
        element: <Demo />
      },
      {
        path: 'settings',
        element: <SettingTabs />
      },
      {
        path: 'inbound',
        element: (
          <InboundLayout>
            <Outlet />
          </InboundLayout>
        ),
        children: [
          {
            index: true, // 👈 默认子路由
            element: <Inbound />
          }
        ]
      },
      {
        path: 'customs',
        element: <Customs />
      },
      {
        path: 'monitor-inbound',
        element: <MonitorInbound />
      },
      {
        path: 'warehouse-area',
        element: <AreaIndex />
      },
      {
        path: 'search',
        element: <Search />
      },
      {
        path: 'outbound-scan',
        element: <Scan />
      },
      {
        path: 'schedule',
        element: <Schedule />
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
])
